import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { DtoBase } from "..";

export class ServerSettingsDto extends DtoBase {
    drop_discovery_results: boolean = false;
    drop_monitor_data: boolean = false;
    disable_agent_auto_update: boolean = false;

    public Write(obj: any, context: any): void {
		obj.server_settings = {};
		obj = obj.server_settings;

        super.Write(obj, context);

        obj.drop_discovery_results = ValueEncoder.EncodeBoolean(this.drop_discovery_results);
        obj.drop_monitor_data = ValueEncoder.EncodeBoolean(this.drop_monitor_data);
        obj.disable_agent_auto_update = ValueEncoder.EncodeBoolean(this.disable_agent_auto_update);
	}

	public Read(obj: any, context: any): void {

		if (!obj.server_settings)
			throw new Error();
		obj = obj.server_settings;

		super.Read(obj, context);

        if (obj.drop_discovery_results !== undefined) {
            this.drop_discovery_results = ValueEncoder.DecodeBoolean(obj.drop_discovery_results);
        }

        if (obj.drop_monitor_data !== undefined) {
            this.drop_monitor_data = ValueEncoder.DecodeBoolean(obj.drop_monitor_data);
        }

        if (obj.disable_agent_auto_update !== undefined) {
            this.disable_agent_auto_update = ValueEncoder.DecodeBoolean(obj.disable_agent_auto_update);
        }
	}
}
